import { createRoute } from '@tanstack/react-router';
import { PendingClaims } from '../pending-claims/index.js';
import { rootRoute } from './index.js';

export const pendingClaimsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/pending-claims',
    component: PendingClaims,
});
